export enum OrderChangeType {
  None = 1,
  Algorithm = 2,
  Dispatch = 3,
  Driver = 4,
  Customer = 5,
}
